import React, { Component } from "react";
import { message } from "antd";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import { ModalItem, ButtonItem, DatePickerItem, TextAreaItem, MensajeError } from "../../../../../Components/Items";
import { formatearFechaHora } from "./planeacion.utils";

class ModalAjustarInicioRealPU extends Component {
  state = { loading: false, fecha: null, motivo: "" };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      const { inicioAjustado, inicioRealAutomatico } = this.props;
      const base = inicioAjustado?.fecha || inicioRealAutomatico;
      this.setState({ loading: false, fecha: base ? moment(base) : moment(), motivo: inicioAjustado?.motivo || "" });
    }
  }

  guardar = (fecha) => {
    if (fecha !== null && !this.state.fecha) {
      MensajeError({ message: "Elige la fecha y hora en que inició la orden" });
      return;
    }
    this.setState({ loading: true });
    axios
      .post(
        "ordenesDeProduccionPU/ajustarInicioReal",
        {
          empresaId: this.props.empresaId,
          usuarioId: this.props.usuarioId,
          ordenId: this.props.ordenId,
          fecha: fecha === null ? null : this.state.fecha.toDate(),
          motivo: this.state.motivo,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(fecha === null ? "Se regresó al inicio automático" : "Inicio real ajustado");
          this.props.onGuardado();
        } else {
          MensajeError({ message: res.data.error || "No se pudo ajustar el inicio" });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  render() {
    const { visible, onCerrar, folio, inicioAjustado, inicioRealAutomatico } = this.props;
    return (
      <ModalItem title={`Ajustar inicio real ${folio || ""}`} visible={visible} spinning={this.state.loading} onCancel={onCerrar} width="35%" paddingTop footer={null}>
        <div style={{ color: "#8c8c8c", fontSize: 12, marginBottom: 12 }}>
          Inicio automático (primer movimiento de Pendiente): <b>{formatearFechaHora(inicioRealAutomatico)}</b>
          {inicioAjustado?.fecha && (
            <div>
              Ajustado a <b>{formatearFechaHora(inicioAjustado.fecha)}</b> por {inicioAjustado.usuarioNombre || "—"} ({formatearFechaHora(inicioAjustado.fechaAjuste)})
            </div>
          )}
        </div>

        <div style={{ fontWeight: 600, marginBottom: 4 }}>Fecha y hora en que realmente inició</div>
        <DatePickerItem
          style={{ width: "100%" }}
          allowClear={false}
          showTime={{ format: "HH:mm", minuteStep: 5 }}
          format="DD/MM/YYYY HH:mm"
          value={this.state.fecha}
          disabledDate={(d) => d && d.isAfter(moment(), "day")}
          onChange={(fecha) => this.setState({ fecha })}
        />

        <div style={{ fontWeight: 600, margin: "12px 0 4px 0" }}>Motivo (opcional)</div>
        <TextAreaItem placeholder="Ej. se registró tarde el movimiento" value={this.state.motivo} onChange={(e) => this.setState({ motivo: e.target.value })} />

        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 16 }}>
          <div>
            {inicioAjustado?.fecha && (
              <ButtonItem blanco onClick={() => this.guardar(null)}>
                Volver al automático
              </ButtonItem>
            )}
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <ButtonItem onClick={onCerrar}>Cancelar</ButtonItem>
            <ButtonItem type="primary" onClick={() => this.guardar()}>
              Guardar
            </ButtonItem>
          </div>
        </div>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  usuarioId: state.user.usuarioId,
});

export default connect(mapStateToProps)(ModalAjustarInicioRealPU);
